import { useQuery } from '@tanstack/react-query';
import { DictResponse } from '@spilca/order_ts/v1/order/enum_pb';
import { QUERY_KEYS } from '@monorepo/helpers';
import { translateNormalizedDictionary } from '@monorepo/dictionary';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useGetBrands = (
  filter: object | undefined,
  active: string | null = null
) => {
  const getBrands = useGetRequest(REQUEST_TYPES.GET_PRICING_BRANDS_REQUEST);
  return useQuery({
    queryKey: [QUERY_KEYS.LIST_PRICING_BRANDS, filter],
    queryFn: (d): Promise<DictResponse.AsObject> => getBrands({ ...d, active }),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 10*60*1000,
    gcTime: 2*60*1000,
    placeholderData: (previousData) => previousData,
    select: translateNormalizedDictionary(
      ({ name, count }) => `${name} (${count})`,
      null,
      'id',
      (item) => `brand-${item.id}-${item.name}`
    )
  });
};

export default useGetBrands;
